/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect  } from "react";
import { useDispatch, useSelector } from "react-redux";
import FilterIcon from "assets/icons/filter-icon.svg";
import CloseIcon from "assets/icons/white-close.svg";
import loader from "assets/images/loader.gif";
import {
  emptyIftCheckList,
  updatePageLimit,
  updateSortByValue,
  updateSearchText,
  resetTextFilters,
  updateTextFilters,
  resetFilterSideBar,
  updatePriceValue,
} from "redux/actions";
import SidebarTheme2 from "../SidebarTheme2";
import "./actions-theme2.scss";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useSearchCategoryChange from 'hooks/useSearchCategoryChange';
import { DEPARTMENT_IFT } from '../FilterSlidebar';
import ProductsFiltersDropdown from "../ProductsFiltersDropdown";

const LoadingIndicator = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <img style={{ width: "100px", height: "50px" }} src={loader} alt="" />
    <span style={{ marginLeft: "10px" }}>Loading, please wait....</span>
  </div>
);

const ClearFiltersButton = ({ onClick }) => (
  <div
    style={{
      marginLeft: "2rem",
      cursor: "pointer",
      textDecoration: "underline",
      color: "blue",
      border: "0",
      backgroundColor: "transparent",
      fontSize: "1rem",
      fontWeight: "bold",
    }}
    className="clear-filter"
    onMouseDown={onClick}
  >
    Clear All
  </div>
);

const ActionsTheme2 = ({
  pageLimit,
  setPageLimit,
  listLimitOption,
  productListByDepartmentTotalCount,
  isShowReorder,
  handleClickAddAllToCart,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const handleChangeSelectedOption = useSearchCategoryChange()
  const {
    pastOrderCheckedList,
    fromCheckedList,
    productListByDepartmentLoading,
  } = useSelector(({ product }) => product);
  const { uncompleteProductMessage } = useSelector(
    ({ customlist }) => customlist
  );

  const [searchParams] = useSearchParams();
  const [isShowMobileFilter, setIsShowMobileFilter] = useState(false);

  const handleChangeOption = (_, value) => {
    setPageLimit(value);
    dispatch(updatePageLimit(value));
  };
  
  useEffect(() => {
    // reset search once we come on the page first time
    dispatch(emptyIftCheckList());
    dispatch(updateSearchText(""));
    dispatch(updateSortByValue(""));
    dispatch(resetTextFilters());
    dispatch(updatePriceValue(["", ""]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  useEffect(() => {
    // if user selects a department from "Shop by department" then auto select that department
    const departmentId = searchParams.get("category_ids");
    if (location.pathname === "/search/products/" && departmentId) {
      if (departmentId !== "-1") {
        dispatch(resetFilterSideBar()); // for normal departments selected from shop by department
        dispatch(updateTextFilters({category: DEPARTMENT_IFT, value: departmentId}))
        navigate(`/search/products/`)
      }
    }
  }, [dispatch, location.pathname, navigate, searchParams])

  return (
    <div>
      <div className="listing-action-section-theme2">
        <div className="listing-grid-wrapper">
        </div>
          <div className="found-section">
        <div className="found-items">
          {!productListByDepartmentLoading &&
            productListByDepartmentTotalCount > 0 && (
              <p>
                We found <span>{productListByDepartmentTotalCount} products</span> for you!
              </p>
            )}
          {!productListByDepartmentLoading &&
            productListByDepartmentTotalCount == 0 && (
              <div style={{ display: "flex" }}>
                <p>
                  Currently there are no products that match your search
                  criteria. Please try searching all products.
                </p>
                <ClearFiltersButton
                  onClick={() => {
                      dispatch(resetTextFilters());
                      dispatch(emptyIftCheckList());
                      dispatch(updateSearchText(""));
                      handleChangeSelectedOption("products")
                      dispatch(updateSortByValue(""));
                      handleChangeOption(pageLimit, listLimitOption[0]?.value);
                      dispatch(updatePriceValue(["", ""]));
                  }}
                />
              </div>
            )}
          {productListByDepartmentLoading && <LoadingIndicator />}
          {!productListByDepartmentLoading && (
            <p className="product-count-mobile-screen">
              <span> {productListByDepartmentTotalCount} items </span>
              {isShowReorder &&
                (!!pastOrderCheckedList.length || !!fromCheckedList.length) && (
                  <button
                    className="add-all-to-cart-button"
                    onClick={handleClickAddAllToCart}
                  >
                    <span>Add All to Cart</span>
                  </button>
                )}
              <div
                className="mobile-filter-button"
                onClick={() => setIsShowMobileFilter(!isShowMobileFilter)}
              >
                <button>
                  <img src={FilterIcon} alt="FilterIcon" />
                  <span>Filter</span>
                </button>
              </div>
            </p>
          )}
        </div>
          <ProductsFiltersDropdown />
          </div>
        <div className="restricted">
          <p>{uncompleteProductMessage && uncompleteProductMessage}</p>
        </div>
      </div>
      <div
        className={
          isShowMobileFilter
            ? "mobile-filter mobile-filter-show"
            : "mobile-filter mobile-filter-hidden"
        }
      >
        <div className="mobile-filter-header">
          <p>Filter</p>
          <div
            className="filter-close"
            onClick={() => setIsShowMobileFilter(false)}
          >
            <img src={CloseIcon} alt="CloseIcon" />
          </div>
        </div>
        <SidebarTheme2
          isMobileSidebar={true}
          isShowReorder={isShowReorder}
        />
      </div>
    </div>
  );
};

export default ActionsTheme2;
